import { useLingui } from "@lingui/react/macro";

export interface RecurrenceLanguage {
  dayNames: string[];
  monthNames: string[];
  tokens: Record<string, RegExp>;
}

export type RecurrenceGetText = (id: unknown) => string;

export function recurrenceLanguage(locale?: string): RecurrenceLanguage {
  return {
    // rrule indexes these with getDay(), so Sunday comes first
    dayNames: Array.from({ length: 7 }, (_, index) =>
      format(new Date(Date.UTC(2024, 0, 7 + index)), locale, {
        weekday: "long",
      }),
    ),
    monthNames: Array.from({ length: 12 }, (_, index) =>
      format(new Date(Date.UTC(2024, index, 1)), locale, { month: "long" }),
    ),
    tokens: {},
  };
}

export function useRecurrenceGetText(): RecurrenceGetText {
  const { t } = useLingui();

  const words: Record<string, string> = {
    every: t`every`,
    until: t`until`,
    day: t`day`,
    days: t`days`,
    week: t`week`,
    weeks: t`weeks`,
    hour: t`hour`,
    hours: t`hours`,
    minute: t`minute`,
    minutes: t`minutes`,
    month: t`month`,
    months: t`months`,
    year: t`year`,
    years: t`years`,
    on: t`on`,
    in: t`in`,
    "on the": t`on the`,
    for: t`for`,
    and: t`and`,
    or: t`or`,
    at: t`at`,
    last: t`last`,
    st: t`st`,
    nd: t`nd`,
    rd: t`rd`,
    th: t`th`,
    time: t`time`,
    times: t`times`,
    weekday: t`weekday`,
    weekdays: t`weekdays`,
  };

  return (id: unknown) => words[String(id)] ?? String(id);
}

function format(
  date: Date,
  locale: string | undefined,
  options: Intl.DateTimeFormatOptions,
): string {
  return new Intl.DateTimeFormat(locale, {
    ...options,
    timeZone: "UTC",
  }).format(date);
}
